import React, { useState, createContext, useEffect } from "react"
import Cookies from "js-cookie"

const ColorModeContext = createContext({
  currentMode: Cookies.get("preferredTheme") || "light",
  toggleColorMode: () => {},
  setColorMode: () => {},
})

export const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState(Cookies.get("preferredTheme") || "light")

  const prefersDarkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches

  const toggleColorMode = () => {
    const newMode = mode === "dark" ? "light" : "dark"
    setMode(newMode)
    Cookies.set("preferredTheme", newMode, { expires: 365 })
  }

  const setColorMode = (modeSetter) => {
    if (modeSetter === "auto") {
      const newMode = prefersDarkMode ? "dark" : "light"
      setMode(newMode)
      Cookies.set("preferredTheme", "auto", { expires: 365 })
      return
    }

    setMode(modeSetter)
    Cookies.set("preferredTheme", modeSetter, { expires: 365 })
  }

  useEffect(() => {
    const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches
    const preferredTheme = Cookies.get("preferredTheme")

    if (!preferredTheme) {
      const initialMode = prefersDarkMode ? "dark" : "light"
      setColorMode(initialMode)
    } else {
      setColorMode(preferredTheme)
    }
  })

  return (
    <ColorModeContext.Provider value={{ currentMode: mode, toggleColorMode, setColorMode }}>
      {children}
    </ColorModeContext.Provider>
  )
}

export { ColorModeContext }
